import { createBrowserRouter, Navigate } from 'react-router-dom';
import { Layout } from '../components/Layout';
import { HomePage } from '../pages/HomePage';
import { NewsPage } from '../pages/NewsPage';
import { NewsPostPage } from '../pages/NewsPostPage';
import { ExamplesPage } from '../pages/ExamplesPage';
import { ExamplePage } from '../pages/ExamplePage';
import { WhatIsPromptLiteracyPage } from '../pages/WhatIsPromptLiteracyPage';
import { ResourcesPage } from '../pages/ResourcesPage';
import { NewsletterPage } from '../pages/NewsletterPage';
import { AboutPage } from '../pages/AboutPage';
import { ContactPage } from '../pages/ContactPage';
import { PrivacyPage } from '../pages/PrivacyPage';
import { TermsPage } from '../pages/TermsPage';
import { TagPage } from '../pages/TagPage';
import { TagsPage } from '../pages/TagsPage';
import { NotFoundPage } from '../pages/NotFoundPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    errorElement: <NotFoundPage />,
    children: [
      {
        index: true,
        element: <HomePage />
      },
      {
        path: 'news',
        children: [
          {
            index: true,
            element: <NewsPage />
          },
          {
            path: ':year/:month/:slug',
            element: <NewsPostPage />
          },
          // Legacy redirect for old slug-only URLs
          {
            path: ':slug',
            element: <NewsPostPage />
          }
        ]
      },
      {
        path: 'examples',
        children: [
          {
            index: true,
            element: <ExamplesPage />
          },
          {
            path: ':slug',
            element: <ExamplePage />
          }
        ]
      },
      {
        path: 'what-is-prompt-literacy',
        element: <WhatIsPromptLiteracyPage />
      },
      {
        path: 'resources',
        element: <ResourcesPage />
      },
      {
        path: 'newsletter',
        element: <NewsletterPage />
      },
      {
        path: 'about',
        element: <AboutPage />
      },
      {
        path: 'contact',
        element: <ContactPage />
      },
      {
        path: 'privacy',
        element: <PrivacyPage />
      },
      {
        path: 'terms',
        element: <TermsPage />
      },
      {
        path: 'tags',
        element: <TagsPage />
      },
      {
        path: 'tag/:slug',
        element: <TagPage />
      },
      // Legacy redirects
      {
        path: 'home',
        element: <Navigate to="/" replace />
      }
    ]
  }
]);

// Route configuration for navigation
export const navigationRoutes = [
  { path: '/', label: 'Home' },
  { path: '/news', label: 'News' },
  { path: '/examples', label: 'Examples' },
  { path: '/resources', label: 'Resources' },
  { path: '/newsletter', label: 'Newsletter' },
  { path: '/about', label: 'About' }
];

// Topic configuration for filtering
export const topicLabels: Record<string, string> = {
  'ai-literacy': 'AI Literacy',
  'prompt-engineering': 'Prompt Engineering',
  'education-policy': 'Education Policy',
  'ethics': 'Ethics',
  'classroom': 'Classroom',
  'tools': 'Tools'
};

export const goalLabels: Record<string, string> = {
  'summarize': 'Summarize',
  'plan': 'Plan',
  'transform': 'Transform',
  'reason': 'Reason',
  'code-adjacent': 'Code-Adjacent'
};

export const audienceLabels: Record<string, string> = {
  'kids': 'Kids',
  'students': 'Students',
  'educators': 'Educators',
  'workplace': 'Workplace'
};

export const complexityLabels: Record<string, string> = {
  'intro': 'Beginner',
  'intermediate': 'Intermediate',
  'advanced': 'Advanced'
};